import { NgModule } from '@angular/core';
import { ToolbarSpacerComponent } from './toolbar-spacer.component';
import { ToolbarComponent } from './toolbar.component';

@NgModule({
  declarations: [ToolbarSpacerComponent, ToolbarComponent],
  exports: [ToolbarSpacerComponent, ToolbarComponent],
})
export class FmntsToolbarModule {}
